import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggleAction(event) {
    const select = event.target;
    const segment = select.closest(".action-slot");
    if (!segment) return;

    const notificationFields = segment.querySelector(".action-notification-fields");
    const workflowFields = segment.querySelector(".action-workflow-fields");

    if (notificationFields) {
      notificationFields.style.display = select.value === "send_notification" ? "" : "none";
    }
    if (workflowFields) {
      workflowFields.style.display = select.value === "trigger_workflow" ? "" : "none";
    }
  }
}
